import styled from 'styled-components';

export const InputWrapper = styled.div`
  display: flex;
  gap: 20px;
  width: 15vw;
  flex-direction: column;
`;
